//
//
//
//

export default {
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className () { // compatible with old type param
      return `weui-icon weui_icon_${this.type} weui-icon-${this.type.replace(/_/g, '-')}`
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/icon/index.vue